import { useCMSPageField } from '@/cms/fields'
import { useIntl } from '@/intl'
import { horizontalGap, Icon, tk, Typography, verticalGap } from '@sunwebgroup/ui-components'
import { isEmpty } from 'ramda'
import { styled } from 'styled-components'
import { MostBookedByLabel } from './MostBookedByLabel'
import { ReadMore } from './ReadMore'

const Wrapper = styled.div`
  padding-top: ${tk('spacing_sm')};
  display: inline-flex;
  flex-direction: column;
`

const MostBookedByLabelWrapper = styled.div`
  width: fit-content;
  margin-bottom: ${tk('spacing_xs')};
`

const UspsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  ${verticalGap('spacing_xs')}
  margin-bottom: ${tk('spacing_lg')};
`

const Usp = styled.div`
  display: flex;
  align-items: center;
  ${horizontalGap('spacing_2xs')}
`

export default function Description() {
  const intl = useIntl()
  const usps = useCMSPageField('PDP.usps')
  const descriptionText = useCMSPageField('PDP.description')

  return (
    <Wrapper>
      <MostBookedByLabelWrapper>
        <MostBookedByLabel />
      </MostBookedByLabelWrapper>

      <UspsWrapper>
        {!isEmpty(usps)
        && usps.map((item, index) => (
          <Usp key={index}>
            <Icon glyph="IconCheckmarkMedium" />
            <Typography $variant="body-md">{item}</Typography>
          </Usp>
        ))}
      </UspsWrapper>
      {descriptionText && (
        <ReadMore heightShown={80} readMoreText={intl.formatMessage({ id: 'description_read_more' })}>
          <Typography $variant="body-md" dangerouslySetInnerHTML={{ __html: descriptionText }} />
        </ReadMore>
      )}
    </Wrapper>
  )
}
